import i18n, { InterpolateOptions, Scope } from "i18n-js";

/**
 * Translates text.
 *
 * @param key The i18n key.
 */

interface TranslateOptions extends InterpolateOptions {
  scope?: Scope;
  message?: string;
  defaults?: Array<{ message: string } | { scope: Scope }>;
  defaultValue?: string;
}

export function translate(key: string, options?: TranslateOptions) {
  return key ? i18n.t(key, options) : undefined;
  // * changed null to undefined to pass string to placeholder
}
